import styleEditResource from './style-edit-resources';
export default {
    fieldStyle: styleEditResource,
    labelStyle: styleEditResource,
    buttonStyle: styleEditResource,
};
